var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        /**
         * Visual type of the button. Omit if primary type.
         */
        this.type = 'primary';
        /**
         * Size of the button (sm | lg). Omit if medium size.
         */
        this.size = 'md';
    }
    Object.defineProperty(ButtonComponent.prototype, "BEM", {
        get: function () {
            var stringArray = ['app-button'];
            stringArray.push("app-button--" + this.type);
            stringArray.push("app-button--" + this.size);
            if (this.enableWrap) {
                stringArray.push("app-button--wrap");
            }
            return stringArray;
        },
        enumerable: true,
        configurable: true
    });
    return ButtonComponent;
}());
export { ButtonComponent };
